import { DatePipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject, OnDestroy, OnInit, signal } from '@angular/core';
import { UserLastSignIn } from '../core';
import { DashboardService, UserService } from '../services';
import { BaseComponent, ConvertDatePipe } from '../shared';
import { DashboardDeviceStatusComponent } from './dashboard-device-status';


/**
 * Component for dashboard page.
 */
@Component({
	selector: 'tsp-dashboard',
	imports: [
		DatePipe,
		ConvertDatePipe,
		DashboardDeviceStatusComponent
	],
	templateUrl: './dashboard.component.html',
	changeDetection: ChangeDetectionStrategy.Eager
})
export class DashboardComponent extends BaseComponent implements OnInit, OnDestroy {

	private readonly userSrv = inject(UserService);
	private readonly dashboardSrv = inject(DashboardService);

	signin = signal<UserLastSignIn | null>(null);


	ngOnInit(): void {
		this.userSrv.getLastSignIn().subscribe({
			next: signin => this.signin.set(signin),
			error: (err: Error) => console.error(err.message)
		});
		this.dashboardSrv.init();
	}


	ngOnDestroy(): void {
		this.dashboardSrv.reset();
	}

}
